const config = {
  enablePayment: process.env.VUE_APP_ENABLE_PAYMENT === 'y',
  apiBaseUrl: process.env.VUE_APP_BASE_URL,
  desertSharedUrlKey: process.env.VUE_APP_DESERT_SHARE_URL_KEY,
  nightSharedUrlKey: process.env.VUE_APP_NIGHT_SHARE_URL_KEY,
  interiorSharedUrlKey: process.env.VUE_APP_INTERIOR_SHARE_URL_KEY,
  webDefaultLeftVideoId: process.env.VUE_APP_DEFAULT_LEFT,
  webDefaultRightVideoId: process.env.VUE_APP_DEFAULT_RIGHT,
  mobileDefaultVideoId: process.env.VUE_APP_MOBILE_DEFAULT_LENS
}

export default config
